import { CrossStorageClient } from 'cross-storage'

let storage = null
let isConnected = false
const WEB_URL = process.env.VUE_APP_WEB_URL

// Initialize cross-storage client
try {
  if (WEB_URL) {
    storage = new CrossStorageClient(WEB_URL, {
      timeout: 5000
    })
  }
} catch (e) {
  console.warn('Cross-storage initialization failed:', e)
}

export default function crossStoragePlugin(store) {
  // Sync auth state to cross-storage whenever it changes
  store.subscribe((mutation, state) => {
    // Only sync auth-related mutations
    if (mutation.type.startsWith('auth/')) {
      syncToCrossStorage(state.auth)
    }
  })

  // Also sync on initial load if user is already logged in
  if (store.getters['auth/loggedIn']) {
    syncToCrossStorage(store.state.auth)
  }

  async function syncToCrossStorage(authState) {
    if (!storage || !WEB_URL) return

    try {
      // Only connect once, reuse connection
      if (!isConnected) {
        await storage.onConnect()
        isConnected = true
      }
      const vuexState = {
        auth: {
          user: authState.user,
          token: authState.token,
          otpVerified: authState.otpVerified,
          customer: authState.customer
        }
      }
      await storage.set('vuex', JSON.stringify(vuexState))
    } catch (e) {
      // Reset connection state on error, will retry next time
      isConnected = false
      // Silently fail - cross-storage is not critical, cookies are fallback
      console.warn('Failed to sync to cross-storage:', e)
    }
  }
}

